export enum CompanyStatusTypeEnum {
  Verified = 'verified',
  NotActivated = 'notActivated',
  Activated = 'activated',
  Deactivated = 'deactivated',
  Blocked = 'blocked',
  Unblocked = 'unblocked',
  Deleted = 'deleted',
}
